var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgResignationLetter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 22,
    viewBox: "0 0 19 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.490234 17.9062V7.80859C0.490234 5.71875 1.58398 4.63477 3.69336 4.63477H5.08984C5.12891 2.45703 6.99414 0.650391 9.30859 0.650391C11.6328 0.650391 13.4883 2.45703 13.5371 4.63477H14.9336C17.0332 4.63477 18.1367 5.71875 18.1367 7.80859V17.9062C18.1367 19.9863 17.043 21.0801 15.1777 21.0801H3.69336C1.58398 21.0801 0.490234 19.9961 0.490234 17.9062ZM6.93555 4.63477H11.6914C11.6523 3.36523 10.6562 2.34961 9.30859 2.34961C7.9707 2.34961 6.97461 3.36523 6.93555 4.63477Z",
    fill: "#84561C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResignationLetter);
export default __webpack_public_path__ + "static/media/resignation_letter.83c8791a5e74337827d8f518c06c0139.svg";
export { ForwardRef as ReactComponent };